<template>
  <div style="width: 95%;">
    <template v-if="loading">
          <Loader :delay="0"></Loader>
    </template>
    <template v-else>
        <b-row>
          <b-col>
            <b-row>
              <b-col cols="5">
                Total PS
              </b-col>
              <b-col cols="1">
                {{feature.properties.total_ps}}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="5">
                PS Activos
              </b-col>
              <b-col cols="1">
                 {{feature.properties.ps_activos}}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="5">
                PS Activos GN
              </b-col>
              <b-col cols="1">
                 {{feature.properties.ps_activos_gn}}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="5">
                PS Activos GLP
              </b-col>
              <b-col cols="1">
                  {{feature.properties.ps_activos_glp}}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="5">
                PS Potenciales
              </b-col>
              <b-col cols="1">
                  {{feature.properties.ps_potenciales}}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="5">
                PS Captados
              </b-col>
              <b-col cols="1">
                  {{feature.properties.ps_captados}}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="5">
                PS No Captablles
              </b-col>
              <b-col cols="1">
                  {{feature.properties.ps_no_captables}}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="5">
                PS Gestión
              </b-col>
              <b-col cols="1">
                  {{feature.properties.ps_en_gestion}}
              </b-col>
            </b-row>

          </b-col>
          <b-col>
            <b-row>
              <b-col cols="5">
                PS uso residencial
              </b-col>
              <b-col cols="1">
                {{feature.properties.ps_residencial}}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="5">
                PS uso Cuarto caldera
              </b-col>
              <b-col cols="1">
                 {{feature.properties.ps_cuarto_de_caldera}}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="5">
                PS uso Comercial
              </b-col>
              <b-col cols="1">
                 {{feature.properties.ps_comercial}}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="5">
                PS uso Industrial
              </b-col>
              <b-col cols="1">
                  {{feature.properties.ps_industrial}}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="5">
                PS SAP
              </b-col>
              <b-col cols="1">
                  {{feature.properties.total_ps_sap}}
              </b-col>
            </b-row>
          </b-col>

          <b-col>
            <b-row>
              <b-col cols="5">
                PS Potencial SH
              </b-col>
              <b-col cols="1">
                {{feature.properties.ps_potencial_sh}}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="5">
                PS Potencial SP
              </b-col>
              <b-col cols="1">
                 {{feature.properties.ps_potencial_sp}}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="5">
                PS Potencial SV
              </b-col>
              <b-col cols="1">
                 {{feature.properties.ps_potencial_sv}}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="5">
                PS Potencial GC
              </b-col>
              <b-col cols="1">
                  {{feature.properties.ps_potencial_gc}}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="5">
                PS Potencial CC
              </b-col>
              <b-col cols="1">
                  {{feature.properties.ps_potencial_cc}}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="5">
                PS Potencial NE
              </b-col>
              <b-col cols="1">
                  {{feature.properties.ps_potencial_ne}}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="5">
                PS Potencial ES
              </b-col>
              <b-col cols="1">
                  {{feature.properties.ps_potencial_es}}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="5">
                PS Potencial PYME
              </b-col>
              <b-col cols="1">
                  {{feature.properties.ps_potencial_pyme}}
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="5">
                PS Potencial CCNE
              </b-col>
              <b-col cols="1">
                  {{feature.properties.ps_potencial_ccne}}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="6">
                Primera puesta en servicio
              </b-col>
              <b-col cols="4" class="tex-left">
                  {{feature.properties.starting_up_first_date}}
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="6">
                Última puesta en servicio
              </b-col>
              <b-col cols="4" class="tex-left">
                  {{feature.properties.starting_up_last_date}}
              </b-col>
            </b-row>
          </b-col>
        </b-row>
    </template>
    </div>
</template>

<style></style>

<script>

import Loader from '@/components/Layout/Loader.vue';

export default {
  props: ['feature'],
  components: {Loader},
  data () {
    return {
      loading: false
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Map/DetailsResidencial/Resumen.vue